import type { CreatedDatabaseResponse, GetDatabaseResponse, ListDatabasesResponse } from '../console.api.types';
import type { AuraDatabase, AuraDatabaseSummary, CreatedDatabase } from '../console.types';

export const transformListDatabasesReponse = ({ data }: ListDatabasesResponse): AuraDatabaseSummary[] =>
  data.map((db) => ({
    id: db.aura_database_id,
    instanceId: db.instance_id,
  }));

export const transformDatabaseResponse = (response: GetDatabaseResponse): AuraDatabase => ({
  id: response.data.aura_database_id,
  instanceId: response.data.instance_id,
  name: response.data.name,
  status: response.data.status,
  relationships: response.data.relationships,
  nodes: response.data.nodes,
  capabilities: response.data.capabilities,
  availableActions: response.data.available_actions,
  createdAt: response.data.created_at,
});

export const transformCreatedDatabaseResponse = (response: CreatedDatabaseResponse): CreatedDatabase => ({
  id: response.data.aura_database_id,
  instanceId: response.data.instance_id,
  name: response.data.name,
  boltUrl: response.data.bolt_url,
});
